import client from "libs/HttpClient";

/**
 * Service class for handling payment.
 */
class NeftService {
  /**
   * Adds a new Phone pay Payment based on the provided request.
   *
   * @param request - The request parameters for adding a Neft payment.
   * @returns A Promise that resolves to the Axios response for the add Neft payment request.
   */
  static storeNeftPayment(request: any) {
    return client.post("admin/neft/store", request);
  }

  /**
   * update a new Phone pay Payment based on the provided request.
   *
   * @param request - The request parameters for adding a Neft payment.
   * @returns A Promise that resolves to the Axios response for the add Neft payment request.
   */
  static updateNeftPayment(request: any) {
    return client.post("admin/neft/update", request);
  }

  /**
   * renew a new Phone pay Payment based on the provided request.
   *
   * @param request - The request parameters for adding a Neft payment.
   * @returns A Promise that resolves to the Axios response for the add Neft payment request.
   */
  static renewNeftPayment(request: any) {
    return client.post("admin/neft/renew", request);
  }
}

export { NeftService };
